import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: () => import('../views/About.vue')
  },
  {
    path: '/services',
    name: 'ServicesPage',
    component: () => import('../views/Services.vue')
  },
  {
    path: '/contact',
    name: 'ContactPage',
    component: () => import('../views/Contact.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router